import { Encrypt } from "../../utils";
import client from "./client";

export * from "./auth.handlers";
export * from "./payeeKyc";
/**
 *
 * @returns Promise<Axios>
 */
export const getCurrencies = () => {
  return client.get("/currencies");
};
export const getPayoutOrders = (limit, offset) => {
  let timezone = new Date().getTimezoneOffset();
  return client.get(`/getPayoutOrders?timezone=${timezone}&limit=${limit}&offset=${offset}`);
}

export const getDashboardDataAPI = () => {
  return client.get(`/getDashboardData`);
}

/**
 *
 * @param { walletAddress: string, currency: string } payload
 * @returns Promise<Axios>
 */
export const checkKyt = (payload) => {
  return client.post("/kyt", payload);
};
/**
 *
 * @returns Promise<Axios>
 */
export const createSumsubApplicant = () => {
  return client.post("/sumsub/create");
};
/**
 *
 * @returns Promise<Axios>
 */
export const checkSumSubStatus = () => {
  return client.get("/sumsub");
};
/**
 * 
 * @param {*} payload 
 * @returns Promise<Axios>
 */
export const logActivity = (payload) => {
  return client.post("/activity/payeeInvite", payload);
};
/**
 * 
 * @param {*} payload 
 * @returns Promise<Axios>
 */
export const checkWithdraw = (payload) => {

  return client.post("/withdraw-check", payload);
};
/**
 * 
 * @param {*} payload 
 * @returns Promise<Axios>
 */
export const withdraw = (payload) => {
  return client.post("/withdraw", payload);
};
/**
 * 
 * @param {*} id 
 * @returns Promise<Axios>
 */
export const getWithdraw = (id) => {
  return client.get(`/order/${id}`);
};
/**
 * 
 * @param {*} data 
 * @returns Promise<Axios>
 */
export const getFees = (data) => {
  return client.post(`/fee`, data);
};
/**
 * 
 * @param {*} update 
 * @returns Promise<Axios>
 */
export const kycSeenStatus = (update) => {
  if (update) {
    // call update api
    return client.post("/kyc/seen");
  } else {
    // check status api
    return client.get("/kyc/seen");
  }
};
/**
 * 
 * @returns Promise<Axios>
 */
export const ping = () => {
  return client.get("/version");
};
/**
 * 
 * @param {*} email 
 * @returns Promise<Axios>
 */
export const checkEmail = ({ email, tcLink, privacyLink, recaptcha }) => {
  return client.post('/check-email', { email, privacyLink, tcLink, recaptcha })
}
/**
 * 
 * @param {*} country 
 * @returns Promise<Axios>
 */
export const getMassPayPaymentMethods = (country) => {
  return client.get(`/methods?country=${country}`);
}
/**
 * 
 * @param data {amount, country, currency, type} 
 * @returns Promise<Axios>
 */
export const getFormAttributes = (data) => {
  return client.get(`/attributes`, { params: data });
}
/**
 * 
 * @param {*} data 
 * @returns Promise<Axios>
 */
export const saveFormAttributes = (data) => {
  const enc = Encrypt(JSON.stringify(data));
  return client.post('/attributes', { encryptedReq: enc })
}
/**
 * 
 * @param {*} payload 
 * @returns Promise<Axios>
 */
export const getFiatFeeStructure = (payload) => {
  const enc = Encrypt(JSON.stringify(payload));
  return client.post('/transfer/check', { encryptedReq: enc })
}
/**
 * 
 * @param {*} payload 
 * @returns Promise<Axios>
 */
export const withdrawFiat = (payload) => {
  const enc = Encrypt(JSON.stringify(payload))
  return client.post('/transfer/create', { encryptedReq: enc })
}
/**
 * 
 * @param {*} amount 
 * @param {*} country 
 * @param {*} type 
 * @returns Promise<Axios>
 */
export const getCurrencyListFiat = (amount, country, type) => client.get(`/fiat/options?amount=${amount || 50}&country=${country}&type=${type}`)

/**
 * 
 * @param {moduleInfo = {current, activity, meta}} data 
 */
export const logEvent = async (data) => {
  if (!data.meta) {
    data.meta = {};
  }
  data.meta.pathname = window.location.pathname;
  try {
    const payload = {
      serviceName: "Payee",
      moduleInfo: data
    }
    const encryptedReq = Encrypt(JSON.stringify(payload))
    await client.post('/activity', { encryptedReq })
  } catch (err) {
    console.log(err);
  }
}


export const logFeedBackOpenTimeApi = () => {
  return client.post('/feedback/opened')
}

export const setupRecurringPaymentApi = (payload) => {
  const encryptedReq = Encrypt(JSON.stringify(payload))
  return client.post('/recurring/add-rule', { encryptedReq });
}

export const updateRecurringPaymentApi = (payload) => {
  const encryptedReq = Encrypt(JSON.stringify(payload));
  return client.post('/recurring/edit-rule', { encryptedReq });
}

export const getRecurringRule = () => {
  return client.get('/recurring/rules')
}

export const updateRecurringStatus = (payload) => {
  const encryptedReq = Encrypt(JSON.stringify(payload));
  return client.post('/recurring/update-status', { encryptedReq });
}

export const downloadMontlyStatementsApi = (payload, accountId) => {
  payload.timezone = new Date().getTimezoneOffset();
  const encodedBuffer = btoa(accountId, 'utf-8');
  return client.get('/account-summary-statement', {
    params: payload, responseType: 'blob',
    headers: {
      'x-api-account': encodedBuffer,
    }
  });
}

export const getFiatServices = (country, currency) => {
  let url = '/services'
  if(country && currency){
    url += `?country=${country}&currency=${currency}`
  }
  return client.get(url);
}

export const getFiatCurrenciesApi = (query = null) => {
  let url = '/fiat/currency';

  if (query?.country) {
    url += `?country=${query.country}`
  }

  return client.get(url);
}

export const getFiatCountriesApi = () => {
  return client.get(`/fiat/country`);
}

export const getFiatBankForm = (currency, country, destinationRecordId) => {
  let q = `/fiat/bank-configuration?currency=${currency}&country=${country}`;
  if(destinationRecordId) {
    q += `&destinationRecordId=${destinationRecordId}`;
  }
  return client.get(q);
}

export const setFiatBankDetails = (payload, currency, country, oldDestinationRecordId = null) => {
  let query = `/fiat/bank-configuration?currency=${currency}&country=${country}`;
  if(oldDestinationRecordId) {
    query += `&oldDestinationRecordId=${oldDestinationRecordId}`;
  }
  return client.post(query, payload);
}

export const getFiatBanks = () => {
  return client.get('/fiat/bank-detail');
}

export const getFiatWithdrawFees = (payload, currency, country ) => {
  return client.post(`/fiat/fees?currency=${currency}&country=${country}`, payload);
}
export const fiatWithdraw = (payload, currency, country) => {
  const enc = Encrypt(JSON.stringify(payload))
  return client.post(`/fiat/transfer?currency=${currency}&country=${country}`, { encryptedReq: enc });
}

/**
 * 
 * @param {*} update 
 * @returns Promise<Axios>
 */
export const bankSeenStatus = (payload) => {
  const enc = Encrypt(JSON.stringify(payload));
  return client.post("/bank/seen", { encryptedReq: enc });
};

/**
 * 
 * @param {*} update 
 * @returns Promise<Axios>
 */
export const deleteBankByTag = (payload) => {
  const enc = Encrypt(JSON.stringify(payload));
  return client.delete(`/fiat/bank/${encodeURIComponent(enc)}`);
};

export const getFiatCounterLimit = (amount, currency) => {
  return client.get(`/fiat/status?amount=${amount}&currency=${currency}`);
}

export const validateBankAccount = (payload) => {
  return client.get(`/fiat/bank-configuration/validate?accountToken=${payload.accountToken}&country=${payload.country}&currency=${payload.currency}`);
}

export const updateBankDetails = (data, payload) => {
  return client.post(`/fiat/bank-configuration/update?accountToken=${data.accountToken}&country=${data.country}&currency=${data.currency}`, payload);
}
export const getMerchantList = () => {
  return client.get('/accounts')
}
export const payeeLogs = (payload) => {
  const enc = Encrypt(JSON.stringify(payload));
  return client.post('/logs', { encryptedReq: enc });
}

export const currencies = () => {
  return client.get('/currencies-config');
}
// get fiat options
export const getFiatOptionsApi = (country, currency, amount) => {
  return client.get(`/fiat/payment-methods?country=${country}&currency=${currency}&amount=${amount || 50}`);

}

export const getComplianceStatus = (country, destinationRecordId, service) => {
  let query = `/compliance-status?country=${country}`;
  if(service) {
    query += `&service=${service}`
  }
  if(destinationRecordId) {
    query += `&destinationRecordId=${destinationRecordId}`
  }
  return client.get(query);
}

export const getFiatStatus = () => {
  return client.get('/fiat-configuration-status');
}
export const getConfiguration = () => {
  return client.get('/login-configuration')
}

export const sendOtp = (payload) => {
  return client.post('/auth/otp/send', payload)
}

export const inviteFriendAPI = (payload) => {
  return client.post('/referral/invite', payload);
}

export const referalSettingsAPI = () => {
  return client.get('/referral/settings');
}

export const referSignup = (payload) => {
  return client.post('/signup', payload);
}

export const getEmailOfreferal = (token) => {
  return client.get(`/referral/email/${token}`);
}

export const getBusinessFieldValues = () => {
  return client.get(`/fiat/business-field-values`)
}
export const userCreate = () => {
  return client.post('/user/create');
}

export const fetchVendorStatus = () => {
  return client.get('/fiat/vendor-status');
}

export const getS3SignnedUrl = (contentType) => {
  return client.get(`/files/upload-url?contentType=${contentType}`);
}

export const getPersonalFields = () => {
  return client.get('/fiat/personal-field-values')
}

export const getPerformanceStatus = () => {
  return client.get('/performance-status');
}

export const getNotification = () => {
  return client.get('/notifications');
}